import { Socket } from "socket.io-client";
import { ensureFreshToken, refreshAccessToken, tokenMsLeft } from "./apiMethods";

export type SocketStatus = "ok" | "disconnected" | "expired";

const KEEP_ALIVE_MS = 5 * 60 * 1000;
let keepAliveStarted = false;

const startTokenKeepAlive = () => {
  if (keepAliveStarted) return;
  keepAliveStarted = true;
  setInterval(() => {
    ensureFreshToken().catch(() => undefined);
  }, KEEP_ALIVE_MS);
};

export const socketAuth = (withTenant: boolean) => {
  startTokenKeepAlive();
  return (cb: (data: object) => void) => {
    ensureFreshToken()
      .catch(() => undefined)
      .then(() => {
        const data: { [key: string]: any } = {
          token: localStorage.getItem("token"),
        };
        if (withTenant) data.tenantFormReact = localStorage.getItem("tenantId");
        cb(data);
      });
  };
};

const recoverFromUnauthorized = (socket: Socket, onExpired: () => void) => {
  let retried = false;
  socket.on("connect", () => {
    retried = false;
  });
  socket.on("connect_error", async (err: Error) => {
    if (err.message !== "unauthorized") return;

    const msLeft = tokenMsLeft();
    if (msLeft === null || msLeft <= 0 || retried) {
      onExpired();
      return;
    }
    retried = true;
    await refreshAccessToken();
    socket.connect();
  });
};

interface WatchHandlers {
  onStatus: (status: SocketStatus) => void;
  onConnect?: () => void;
}

export const watchSocket = (socket: Socket, handlers: WatchHandlers) => {
  socket.on("connect", () => {
    handlers.onStatus("ok");
    if (handlers.onConnect) handlers.onConnect();
  });
  socket.on("disconnect", (reason: string) => {
    if (reason !== "io client disconnect") handlers.onStatus("disconnected");
  });
  recoverFromUnauthorized(socket, () => handlers.onStatus("expired"));
};
